<style lang="scss" scoped>
.radar {
    width: 100%;
    height: 100%;

}
</style>
<template>
    <div class="radar">
        <chart-base :options="option"></chart-base>
    </div>
</template>
<script>
export default {
    name: 'custom-radarCharts',
    data() {
        return {
            option: {}
        }
    },
    props: {
        radarList: {
            type: Array,
            default: () => {
                return [
                        { name: '企业类型', max: 6500 },
                        { name: '企业类型', max: 16000 },
                        { name: '企业类型', max: 30000 },
                        { name: '企业类型', max: 38000 },
                        { name: '企业类型', max: 52000 },
                        { name: '企业类型', max: 25000 }
                    ]
            }
        }
    },
    watch: {
        radarList() {
            this.loadOption()
        }
    },
    methods: {
        loadOption() {
            this.option = {
                  
                radar: {
                    startAngle:60,
                    borderColor: 'red',
                    // shape: 'circle',
                    splitNumber: 4,//雷达圈数
                    indicator: this.radarList,
                    name:{
                        textStyle:{
                            padding:[5,0],
                            color:"white",
                            fontSize:14
                        }
                    },
                    // 缩放
                    radius:50,
                    // 图表背景的颜色
                    splitArea: {
                        show: false,
                        areaStyle: {
                            color: ['rgba(0,0,0,0)', 'rgba(0,0,0,0)', 'rgba(0,0,0,0)', 'red'],
                        },
                    },
                    // 设置雷达图中间射线的颜色
                    // axisLine: {
                    //     lineStyle: {
                    //         color: "red",
                    //     },
                    // },
                    // 设置网格的颜色
                    splitLine: {
                        show: true,
                        lineStyle: {
                            width: 1,
                            color: ['rgba(255, 255, 255, 0.7)', 'rgba(255, 255, 255, 0.7)', 'rgba(255, 255, 255, 0.7)', 'rgba(255, 255, 255, 0.7)', 'rgba(255, 159, 70, 0.5)'],
                        },
                    },
                    // startAngle:-30,//网格旋转角度
                },
                series: [
                    {
                    // radius:"50%",
                        name: '',
                        type: 'radar',
                        itemStyle: {
                            color: 'rgba(255, 159, 70, 1)',
                        },
                        data: [
                            {
                                value: [4200, 3000, 20000, 35000, 50000, 18000],
                                name: '',
                                // 雷达覆盖区域颜色
                                areaStyle: {
                                    normal: {
                                        color: "rgba(255, 159, 70, .15)",
                                    },
                                },
                                // 覆盖区域线宽
                                lineStyle:{
                                    width:2
                                }
                            },
                        ]
                    }
                ]
            }
        }
    },
    created() {
        this.loadOption()
    }
}
</script>